import { Form as _Form } from "@byte-design/ui/es/components/form";
import { DateRangePicker as _DateRangePicker } from "@byte-design/ui/es/components/date-range-picker";
export var FieldDateRangePicker = _Form.withField(_DateRangePicker, [], {
  displayName: 'FieldDateRangePicker',
  useInputRef: false,
  useDomRef: false
});